import React from "react";
import { Link } from "react-router";
import checkAuth from "../requireAuth";
import html2pdf from "html2pdf.js";
import { connect } from "react-redux";
import moment from "moment";
import { year_wages, brp_bonus_wages } from "../home/wages";
import {
  year_2018_proportions_new,
  year_2018_proportions,
  headship_hours,
} from "../home/restrictions.js";
import { glosary, glosary_abreviations } from "../home/glosary";
import FirebaseApi from "../../api/firebase";

class ProtectedPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = props.contractInfo;
    /*
    this.state.manual_1 = ''
    this.state.manual_2 = ''
    this.state.comment = ''
    */

    this.state.sep_2_value_type = "";
    this.state.sep_3_value_type = "";

    if (props.info != null) {
      this.state = props.info;
    }

    props.info.manual_1 == null ? (this.state.manual_1 = "") : "";
    props.info.manual_2 == null ? (this.state.manual_2 = "") : "";
    props.info.comment == null ? (this.state.comment = "") : "";
    props.info.segment_assignation == null
      ? (this.state.segment_assignation = 0)
      : "";
    props.info.complementary_payroll == null
      ? (this.state.complementary_payroll = 0)
      : "";

    props.info.sep_1_value == null ? (this.state.sep_1_value = 0) : "";
    props.info.sep_2_value == null ? (this.state.sep_2_value = 0) : "";

    //this.state = props.contractInfo
  }

  componentWillMount = () => {
    this.retrieveHourValues();
  };

  retrieveHourValues = () => {
    let year = moment(this.state.signing_date, "DD-MM-YYYY").year();
    FirebaseApi.GetValues("/hour_values/" + year)
      .then((snap) => {
        let hour_values_obj = snap.val();
        if (hour_values_obj) {
          this.hour_values = {
            A: hour_values_obj["A"],
            B: hour_values_obj["B"],
            C: hour_values_obj["C"],
          };
          this.forceUpdate();
          console.log(this.hour_values);
        } else {
          alert("No existen valores hora para la fecha de firma elegida ");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  downloadPDF = () => {
    //var doc = new jsPDF()
    //doc.fromHTML($('.pdf').get(0), 15, 15, {
    //'width': 170,
    //});
    //doc.save('a4.pdf')
    var element = document.getElementById("pdf-container");
    html2pdf(element, {
      margin: [0.05, 0.5, 0.05, 0.5],
      filename: "myfile.pdf",
      image: { type: "jpeg", quality: 0.8 },
      html2canvas: { dpi: 500, letterRendering: true },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    });
  };

  Export2Doc = (element, filename = "") => {
    var preHtml =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = "</body></html>";
    var html = preHtml + document.getElementById(element).innerHTML + postHtml;

    var blob = new Blob(["\ufeff", html], {
      type: "application/msword",
    });

    // Specify link url
    var url =
      "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

    // Specify file name
    filename = filename ? filename + ".doc" : "document.doc";

    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = url;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  };

  exportHTML = () => {
    var header =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
      "xmlns:w='urn:schemas-microsoft-com:office:word' " +
      "xmlns='http://www.w3.org/TR/REC-html40'>" +
      "<head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title></head><body>";
    var footer = "</body></html>";
    var sourceHTML =
      header + document.getElementById("pdf-container").innerHTML + footer;

    var source =
      "data:application/vnd.ms-word;charset=utf-8," +
      encodeURIComponent(sourceHTML);
    var fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = "document.doc";
    fileDownload.click();
    document.body.removeChild(fileDownload);
  };
  calculateHeadshipHours = () => {
    let headship = this.state.headship.value;
    let sep_1_hours = 0;
    sep_1_hours = headship_hours[headship].payable;
    return sep_1_hours;
  };

  calculateHeadshipHourPrice = () => {
    let headship = this.state.headship.value;
    console.log(headship);
    let sep_1_hour_price = 0;
    if (
      headship == "parvularia" ||
      headship == "básica_1_a_4" ||
      headship == "básica_5_a_6" ||
      headship == "básica_7_a_8"
    ) {
      sep_1_hour_price = this.getYearHourValue("middle");
    } else if (headship == "media") {
      sep_1_hour_price = this.getYearHourValue("high");
    }

    return sep_1_hour_price;
  };

  getHeadshipType = () => {
    let headship = this.state.headship.value;
    let headship_type = "N.A";
    if (
      headship == "parvularia" ||
      headship == "básica_1_a_4" ||
      headship == "básica_5_a_6" ||
      headship == "básica_7_a_8"
    ) {
      headship_type = "básica";
    } else if (headship == "media") {
      headship_type = "media";
    }

    return headship_type;
  };

  generateFinalScheduleGrid = () => {
    let final_grid = this.state.final_grid;
    let detailed_grid_row_cursor = 1;
    for (
      let period = 0;
      period < this.state.block_to_detailed_mapping.length;
      period += 1
    ) {
      let current_period_mapping = this.state.block_to_detailed_mapping[period];
      //Loop over each day
      let current_detailed_grid_row_cursor = detailed_grid_row_cursor;
      for (
        let day = 3;
        detailed_grid_row_cursor < this.state.detailed_grid.length &&
        day < this.state.detailed_grid[detailed_grid_row_cursor].length;
        day += 1
      ) {
        let cell_content = { strings: [], objects: [] };
        current_detailed_grid_row_cursor = detailed_grid_row_cursor;
        for (
          let interval = 0;
          interval < current_period_mapping.rows;
          interval++
        ) {
          if (
            cell_content.strings.indexOf(
              this.state.detailed_grid[current_detailed_grid_row_cursor][day]
                .value
            ) == -1
          ) {
            cell_content.strings.push(
              this.state.detailed_grid[current_detailed_grid_row_cursor][day]
                .value
            );
            cell_content.objects.push({
              string:
                this.state.detailed_grid[current_detailed_grid_row_cursor][day]
                  .value,
              duration: 5,
            });
          } else {
            let index_of_string = cell_content.strings.indexOf(
              this.state.detailed_grid[current_detailed_grid_row_cursor][day]
                .value
            );
            cell_content.objects[index_of_string].duration += 5;
          }
          current_detailed_grid_row_cursor += 1;
        }
        //Generate compound cell content
        let cell_content_string = "";
        for (let i = 0; i < cell_content.objects.length; i++) {
          if (cell_content.strings[i] != "") {
            if (cell_content_string.length > 0) {
              cell_content_string += ",";
            }
            cell_content_string +=
              " " +
              this.abreviate(cell_content.strings[i]) +
              "(" +
              cell_content.objects[i].duration +
              ")";
          }
        }
        final_grid[period + 1][day].value = cell_content_string;
      }
      detailed_grid_row_cursor = current_detailed_grid_row_cursor;
    }
  };

  abreviate = (value) => {
    if (glosary.includes(value.toLowerCase().trim())) {
      let obj = glosary_abreviations.find(function (obj) {
        return obj.value === value.toLowerCase().trim();
      });
      return obj.abreviation;
    } else {
      return value;
    }
  };

  inputChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({ [name]: value }, () => {
      //Call parent setstate, TODO
      this.props.setComments(
        this.state.manual_1,
        this.state.manual_2,
        this.state.comment
      );
    });
  };

  inputChangeNumber = (event) => {
    let name = event.target.name;
    let value = parseFloat(event.target.value);

    this.setState({ [name]: value }, () => {
      //Call parent setstate, TODO
      this.props.setExtraHours(
        this.state.segment_assignation,
        this.state.complementary_payroll
      );
      this.props.setNewSepValues(
        this.state.sep_1_value,
        this.state.sep_2_value
      );
    });
  };

  translate = (full_word) => {
    let split = full_word.split(",");
    let ret = "";
    split.forEach((val, index) => {
      index > 0 ? (ret += ", ") : "";
      let word =
        val.indexOf("(") > 0 ? val.slice(0, val.indexOf("(")).trim() : val;
      let complement = val.slice(val.indexOf("("), val.length);
      let result = this.translateSwitch(word, complement);
      ret += result;
    });

    return ret;
  };

  translateSignDateToPeriod = () => {
    let date = moment(this.state.signing_date, "DD-MM-YYYY");

    //If date is January of February it corresponds to the previous academic period
    if (date.month() < 2) {
      return "marzo " + (date.year() - 1) + " -  febrero " + date.year();
    } else {
      return "marzo " + date.year() + " -  febrero " + (date.year() + 1);
    }
  };

  translateSwitch = (word, complement) => {
    switch (word) {
      case "AB":
        return "Aula Básica" + complement;
      case "AM":
        return "Aula Media" + complement;
      case "HS1":
        return "SEP1" + complement;
      case "HS2":
        return "SEP2" + complement;
      case "HS3":
        return "SEP3" + complement;
      case "COL":
        return "Complementaria" + complement;
      case "DSC":
        return "Recreo Docente" + complement;
      case "HNL":
        return "No Lectiva" + complement;
      case "FTL":
        return "Flotancia" + complement;
      default:
        return word;
    }
  };

  calculateProportions = () => {
    let classroom_minutes =
      this.state.categories_minutes.middle_classroom +
      this.state.categories_minutes.high_classroom;

    //We dont have to add float minutes anymore
    //this.state.categories_minutes.float == null ? "" : classroom_minutes+=  this.state.categories_minutes.float
    let non_academic_and_break_minutes =
      this.state.categories_minutes.non_academic +
      this.state.categories_minutes.break;

    let sum = classroom_minutes + non_academic_and_break_minutes;
    let classroom_proportion = Math.round((classroom_minutes / sum) * 100);
    let non_academic_and_break_proportion = Math.round(
      (non_academic_and_break_minutes / sum) * 100
    );
    return classroom_proportion + "/" + non_academic_and_break_proportion;
  };

  replaceAll = (str, find, replace) => {
    //return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
    return str.replace(new RegExp(find, "g"), replace);
  };

  getYearHourValue = (type) => {
    let period_letter = String.fromCharCode(65 + this.state.startPeriod);
    let hour_values_array_index = this.state.startDate - 1992;
    let ret = 0;
    console.log(this.hour_values);
    console.log(period_letter);
    console.log(hour_values_array_index);
    if (this.hour_values != null) {
      type == "high"
        ? (ret = this.hour_values[period_letter][hour_values_array_index].high)
        : (ret =
            this.hour_values[period_letter][hour_values_array_index].middle);
    }

    return ret;
  };

  overwriteTaxableSalaryValues = (old_salary) => {
    let salary = JSON.parse(JSON.stringify(old_salary));
    //Overwrite sep1 and sep2 vaLues if != 0
    if (this.state.sep_1_value > 0 && this.state.sep_1_value) {
      salary.sep_1.salary = this.state.sep_1_value * salary.sep_1.hours;
    } else {
      salary.sep_1.salary = this.state.salary.taxable.sep_1.salary;
    }

    if (this.state.sep_2_value > 0 && this.state.sep_2_value) {
      salary.sep_2.salary = this.state.sep_2_value * salary.sep_2.hours;
    } else {
      salary.sep_2.salary = this.state.salary.taxable.sep_2.salary;
    }
    return salary;
  };

  handleSep2TypeChange = (event) => {
    this.setState({
      sep_2_value_type: event.target.value,
    });
  };

  handleSep3TypeChange = (event) => {
    this.setState({
      sep_3_value_type: event.target.value,
    });
  };

  render() {
    moment.locale("es");
    this.generateFinalScheduleGrid();
    let second_block_row_salaries = [
      this.state.salary.taxable.brp_titulo.salary,
      this.state.salary.taxable.brp_mencion.salary,
      this.state.salary.taxable.ley.salary,
      this.state.salary.taxable.ley_pie.salary,
    ];
    //let second_block_row_salaries = [1,1,1,1]

    return (
      <div className="jumbotron">
        <div className="pdf-gen-container">
          <div className="modifiers">
            <h1 className="title">Modificadores</h1>
            <div className="inputs">
              <div className="form-group w-75">
                <h3>Sep 1</h3>
                <label htmlFor="name">Valor Hora Sep 1</label>
                <input
                  value={this.state.sep_1_value}
                  type="number"
                  name="sep_1_value"
                  onChange={this.inputChangeNumber}
                  className="form-control"
                />
              </div>
              <h3>Sep 2</h3>
              <div className="form-group w-75">
                <label htmlFor="name">Valor Hora Sep 2</label>
                <input
                  value={this.state.sep_2_value}
                  type="number"
                  name="sep_2_value"
                  onChange={this.inputChangeNumber}
                  className="form-control"
                />
              </div>
              <div className="form-group w-75">
                <label htmlFor="name">Texto horas SEP 2</label>
                <input
                  value={this.state.manual_1}
                  type="text"
                  name="manual_1"
                  onChange={this.inputChange}
                  className="form-control"
                />
              </div>
              {this.state.sep_2_value != 0 ? (
                <div className="form-group w-75">
                  <label>Valor Hora Referencial Sep 2</label>
                  <div className="radio">
                    <label>
                      <input
                        type="radio"
                        value="middle"
                        checked={this.state.sep_2_value_type === "middle"}
                        onChange={this.handleSep2TypeChange}
                      />
                      Básica
                    </label>
                  </div>
                  <div className="radio">
                    <label>
                      <input
                        type="radio"
                        value="high"
                        checked={this.state.sep_2_value_type === "high"}
                        onChange={this.handleSep2TypeChange}
                      />
                      Media
                    </label>
                  </div>
                </div>
              ) : (
                ""
              )}
              <h3>Sep 3</h3>
              <div className="form-group w-75">
                <label htmlFor="name">Texto horas SEP 3</label>
                <input
                  value={this.state.manual_2}
                  type="text"
                  name="manual_2"
                  onChange={this.inputChange}
                  className="form-control"
                />
              </div>
              {this.state.salary.taxable.sep_3.hours > 0 ? (
                <div className="form-group w-75">
                  <label>Valor Hora Referencial Sep 3</label>
                  <div className="radio">
                    <label>
                      <input
                        type="radio"
                        value="middle"
                        checked={this.state.sep_3_value_type === "middle"}
                        onChange={this.handleSep3TypeChange}
                      />
                      Básica
                    </label>
                  </div>
                  <div className="radio">
                    <label>
                      <input
                        type="radio"
                        value="high"
                        checked={this.state.sep_3_value_type === "high"}
                        onChange={this.handleSep3TypeChange}
                      />
                      Media
                    </label>
                  </div>
                </div>
              ) : (
                ""
              )}
              <h3>Complementario</h3>
              <div className="form-group w-75">
                <label htmlFor="name">Asignación de tramo</label>
                <input
                  value={this.state.segment_assignation}
                  type="number"
                  name="segment_assignation"
                  onChange={this.inputChangeNumber}
                  className="form-control"
                />
              </div>
              <div className="form-group w-75">
                <label htmlFor="name">Planilla Complementaria</label>
                <input
                  value={this.state.complementary_payroll}
                  type="number"
                  name="complementary_payroll"
                  onChange={this.inputChangeNumber}
                  className="form-control"
                />
              </div>
              <div className="form-group w-75">
                <label htmlFor="name">Comentario</label>
                <textarea
                  value={this.state.comment}
                  type="textarea"
                  name="comment"
                  onChange={this.inputChange}
                  className="form-control"
                />
              </div>
            </div>
            <div className="gen-button">
              <button
                className="btn btn-success"
                onClick={() => this.downloadPDF()}
              >
                Descargar PDF
              </button>
            </div>
          </div>
          <div className="preview">
            <div className="title">
              <h1>Pre-visualización PDF Anexo</h1>
            </div>
            <div className="pdf-container" id="pdf-container">
              <div className="pdf" style={{ display: "" }} id="pdf">
                <div className="pdf-header">
                  <div>
                    <div>FUNDACIÓN ASTORECA</div>
                    <div>Colegio {this.state.selectedOption.label}</div>
                  </div>
                  <div>
                    Santiago,{" "}
                    {moment(this.state.signing_date, "DD-MM-YYYY").format(
                      "D [de] MMMM [de] YYYY"
                    )}
                  </div>
                </div>
                <div className="pdf-title-container">
                  <div className="pdf-title">
                    <div className="pdf-title-text">
                      <pre>ANEXO</pre>
                      <pre> AL</pre>
                      <pre> CONTRATO</pre>
                      <pre> DE</pre>
                      <pre> TRABAJO</pre>
                    </div>
                    <div className="pdf-title-year">
                      {moment(this.state.signing_date, "DD-MM-YYYY").year()}
                    </div>
                  </div>
                </div>
                <div className="contract-info-container">
                  <div className="worker-name-container">
                    <div className="worker-name-label bold">Trabajador:</div>
                    <div className="worker-name">{this.state.teacher.name}</div>
                  </div>
                  <div className="contract-date-container">
                    <div className="contract-date-label bold">
                      Fecha de contrato de trabajo:
                    </div>
                    <div className="contract-date">
                      {moment(
                        this.state.teacher.start_date,
                        "DD-MM-YYYY"
                      ).format("D [de] MMMM [de] YYYY")}
                    </div>
                  </div>
                </div>
                <div className="schedule-info-container">
                  <div className="year-info-2">
                    <div className="year-info-label">
                      Horario semanal año escolar
                    </div>
                    <div className="year-info-number">
                      {moment(this.state.signing_date, "DD-MM-YYYY").year()}
                    </div>
                  </div>
                  <div className="schedule-container">
                    <table className="pdf-schedule">
                      <thead>
                        <tr>
                          <th colSpan="2" className="colspan-2-header">
                            <span className="pdf-cell">Horario</span>
                          </th>
                          <th className="day-header">
                            <span className="pdf-cell">Lunes</span>
                          </th>
                          <th className="day-header">
                            <span className="pdf-cell">Martes</span>
                          </th>
                          <th className="day-header">
                            <span className="pdf-cell">Miércoles</span>
                          </th>
                          <th className="day-header">
                            <span className="pdf-cell">Jueves</span>
                          </th>
                          <th className="day-header">
                            <span className="pdf-cell">Viernes</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.final_grid
                          .slice(1)
                          .map((subarray, index) => (
                            <tr
                              key={index}
                              className={
                                subarray[0].value.includes("Recreo")
                                  ? "break-cell"
                                  : ""
                              }
                            >
                              {subarray[0].value.includes("Recreo") ? (
                                <td
                                  className="header-cell"
                                  key="header-recreo"
                                  colSpan="2"
                                >
                                  <span className="pdf-cell">
                                    Recreo del Alumno
                                  </span>
                                </td>
                              ) : (
                                ""
                              )}
                              {subarray[0].value.includes("Recreo")
                                ? subarray
                                    .slice(3, subarray.length)
                                    .map((val, index2) => (
                                      <td
                                        className={
                                          index2 >= 0
                                            ? "content-cell"
                                            : "header-cell"
                                        }
                                        key={index2}
                                      >
                                        <span className="pdf-cell">
                                          {this.translate(val.value)}
                                        </span>
                                      </td>
                                    ))
                                : subarray.slice(1).map((val, index2) => (
                                    <td
                                      className={
                                        index2 > 1
                                          ? "content-cell"
                                          : "header-cell"
                                      }
                                      key={index2}
                                    >
                                      <span className="pdf-cell">
                                        {this.translate(val.value)}
                                      </span>
                                    </td>
                                  ))}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="year-info">
                    <div className="proportion-section">
                      La proporción horas aula / (horas no lectivas + recreo
                      docente) de este anexo de contrato es{" "}
                      {this.calculateProportions()}.
                    </div>
                  </div>
                </div>
                <div className="glosary-container">
                  <div className="glosary">
                    <div className="glosary-header">
                      <span className="underlined bold">
                        Horas de contrato base:
                      </span>{" "}
                      las siguientes horas forman parte del contrato base del
                      docente. Estas horas se valorizan de acuerdo al valor hora
                      cronológica básica o media, según la proporción aula
                      básica / aula media del horario.
                    </div>
                    <div className="glosary-entry">
                      <span className="bold">Aula Básica/Media:</span> hora
                      pedagógica frente a cursos de enseñanza básica/media.
                    </div>
                    <div className="glosary-entry">
                      <span className="bold">PIEB/PIEM:</span> hora pedagógica
                      asociada al Programa de Integración Escolar.
                    </div>
                    <div className="glosary-entry">
                      <span className=" bold">Flotancia:</span>  reemplazo de
                      docentes ausentes y realización de tareas pedagógicas
                      y administrativas complementarias.
                    </div>
                    <div className="glosary-entry">
                      <span className="bold">No Lectiva: </span> hora para
                      labores educativas complementarias a la función docente de
                      aula; tales como, preparación y seguimiento de las
                      actividades de aula, evaluación de los aprendizajes,
                      labores de desarrollo profesional y trabajo colaborativo
                      entre docentes. Asimismo, actividades que contribuyen al
                      desarrollo de la comunidad escolar, por ejemplo: atención
                      de estudiantes y apoderados, actividades asociadas a la
                      responsabilidad de jefatura de curso, actividades
                      complementarias al plan de estudios o extraescolares de
                      índole cultural, científica, deportiva u otras actividades
                      que contribuyan al mejor desarrollo del proceso educativo
                      y al cumplimiento del Proyecto Educativo Institucional y
                      del Proyecto de Mejoramiento Educativo (Extracto del
                      artículo 4° de la ley 20.903).
                    </div>
                    <div className="glosary-entry">
                      <span className=" bold">Recreo Docente:</span> la norma en
                      educación establece 4 minutos de recreo docente por cada
                      45 minutos de aula, los que podrán acumularse para los
                      efectos de conformar el horario diario de clases.
                    </div>
                    <div className="glosary-entry">
                      <span className=" bold">Complementaria:</span> destinadas
                      a acciones académicas y formativas orientadas al
                      desarrollo integral de los alumnos del colegio.
                    </div>
                    <div className="glosary-header">
                      <span className="underlined bold">
                        Horas adicionales durante el período escolar{" "}
                        {this.translateSignDateToPeriod()}:
                      </span>{" "}
                      las siguientes horas se consideran para la remuneración
                      del período escolar {this.translateSignDateToPeriod()} y
                      podrán ser modificadas para el próximo período escolar.
                    </div>
                    <div className="glosary-entry">
                      <span className=" bold">SEP1:</span> destinadas a
                      funciones propias de la de jefatura de curso y asociadas
                      al Plan de Mejoramiento Educativo del colegio.
                    </div>
                    <div className="glosary-entry">
                      <span className="bold">SEP2:</span> destinadas a
                      actividades y/o funciones asociadas al Plan de
                      Mejoramiento Educativo del colegio, tales como, talleres
                      extra programáticos, horas de pastoral, mantención de
                      instrumentos musicales, entre otras.
                    </div>
                    <div className="glosary-entry">
                      <span className=" bold">SEP3:</span> destinadas a
                      actividades y/o funciones asociadas al Plan de
                      Mejoramiento Educativo del colegio, tales como, horas de
                      mentorías, jefatura de departamento, entre otras.
                    </div>
                  </div>
                </div>
                <div className="flex-filler"></div>
                <div className="page-number">1/2</div>
              </div>
              <div className="pdf">
                <div className="pdf-header">
                  <div>
                    <div>FUNDACIÓN ASTORECA</div>
                    <div>Colegio {this.state.selectedOption.label}</div>
                  </div>
                </div>
                <div className="year-info-3">
                  <div className="year-info-label">
                    Remuneración año escolar
                  </div>
                  <div className="year-info-number-2">
                    {moment(this.state.signing_date, "DD-MM-YYYY").year()}
                  </div>
                </div>
                <div className="summary-container">
                  <div className="pdf-summary">
                    <div className="summary-headers-block">
                      <div className="headers-fill"></div>
                      <div className="summary-headers">
                        <div className="summary-header-filler"></div>
                        <div className="summary-header">horas</div>
                        <div className="summary-header">valor hora</div>
                        <div className="summary-header">total</div>
                      </div>
                    </div>
                    <div className="summary-first-block">
                      <div className="legend-container">Remuneración base</div>
                      <div className="basic-middle-summary">
                        <div className="summary-row">
                          <div className="summary-row-title">Horas básica</div>
                          <div className="summary-row-detail">
                            {this.state.salary.taxable.base.middle_hours}
                          </div>
                          <div className="summary-row-detail">
                            $
                            {this.replaceAll(
                              this.getYearHourValue("middle").toLocaleString(),
                              ",",
                              "."
                            )}
                          </div>
                          <div className="summary-row-detail">
                            $
                            {this.replaceAll(
                              Math.round(
                                this.getYearHourValue("middle") *
                                  this.state.salary.taxable.base.middle_hours
                              ).toLocaleString(),
                              ",",
                              "."
                            )}
                          </div>
                        </div>
                        <div className="summary-row">
                          <div className="summary-row-title">Horas media</div>
                          <div className="summary-row-detail">
                            {this.state.salary.taxable.base.high_hours}
                          </div>
                          <div className="summary-row-detail">
                            $
                            {this.replaceAll(
                              this.getYearHourValue("high").toLocaleString(),
                              ",",
                              "."
                            )}
                          </div>
                          <div className="summary-row-detail">
                            $
                            {this.replaceAll(
                              Math.round(
                                this.getYearHourValue("high") *
                                  this.state.salary.taxable.base.high_hours
                              ).toLocaleString(),
                              ",",
                              "."
                            )}
                          </div>
                        </div>
                        <div className="imposable-total-container-classroom">
                          <div className="imposable-total-detail-classroom">
                            <div className="summary-row-title">
                              Total remuneración base
                            </div>
                            <div className="summary-row-detail">
                              {this.state.salary.taxable.base.middle_hours +
                                this.state.salary.taxable.base.high_hours}
                            </div>
                            <div className="summary-row-detail"></div>
                            <div className="summary-row-detail">
                              $
                              {this.replaceAll(
                                Math.round(
                                  Math.round(
                                    this.getYearHourValue("high") *
                                      this.state.salary.taxable.base.high_hours
                                  ) +
                                    Math.round(
                                      this.getYearHourValue("middle") *
                                        this.state.salary.taxable.base
                                          .middle_hours
                                    )
                                ).toLocaleString(),
                                ",",
                                "."
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="summary-middle-block">
                      {this.calculateHeadshipHours() > 0 ? (
                        <div className="summary-row-middle">
                          <div className="left-summary-row">
                            <div className="left-summary-row-detail">
                              Horas de jefatura
                            </div>
                            <div className="left-summary-row-detail-middle">
                              {this.getHeadshipType()}
                            </div>
                            <div className="left-summary-row-detail-right">
                              {moment(
                                this.state.signing_date,
                                "DD-MM-YYYY"
                              ).year()}
                            </div>
                          </div>
                          <div className="right-summary-row">
                            <div className="summary-row-title">Horas Sep 1</div>
                            <div className="summary-row-detail">
                              {this.state.salary.taxable.sep_1.hours}
                            </div>
                            <div className="summary-row-detail">
                              $
                              {this.replaceAll(
                                this.calculateHeadshipHourPrice().toLocaleString(),
                                ",",
                                "."
                              )}
                            </div>
                            <div className="summary-row-detail">
                              $
                              {this.replaceAll(
                                Math.round(
                                  this.state.salary.taxable.sep_1.salary
                                ).toLocaleString(),
                                ",",
                                "."
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.salary.taxable.sep_2.hours > 0 ? (
                        <div className="summary-row-middle">
                          <div className="left-summary-row">
                            <div className="left-summary-row-detail">
                              Horas de
                            </div>
                            <div className="left-summary-row-detail-middle">
                              {this.state.manual_1}
                            </div>
                            <div className="left-summary-row-detail-right">
                              {moment(
                                this.state.signing_date,
                                "DD-MM-YYYY"
                              ).year()}
                            </div>
                          </div>
                          <div className="right-summary-row">
                            <div className="summary-row-title">Horas Sep 2</div>
                            <div className="summary-row-detail">
                              {this.state.salary.taxable.sep_2.hours}
                            </div>
                            <div className="summary-row-detail">
                              $
                              {this.state.sep_2_value_type == ""
                                ? this.replaceAll(
                                    this.state.sep_2_value == 0
                                      ? Math.round(
                                          this.state.salary.taxable.sep_2
                                            .salary /
                                            this.state.salary.taxable.sep_2
                                              .hours
                                        ).toLocaleString()
                                      : this.state.sep_2_value.toLocaleString(),
                                    ",",
                                    "."
                                  )
                                : this.replaceAll(
                                    this.getYearHourValue(
                                      this.state.sep_2_value_type
                                    ).toLocaleString(),
                                    ",",
                                    "."
                                  )}
                            </div>
                            <div className="summary-row-detail">
                              $
                              {this.state.sep_2_value_type == "" ||
                              !this.state.sep_2_value_type
                                ? this.replaceAll(
                                    Math.round(
                                      this.state.sep_2_value == 0
                                        ? this.state.salary.taxable.sep_2.salary
                                        : this.state.sep_2_value *
                                            this.state.salary.taxable.sep_2
                                              .hours
                                    ).toLocaleString(),
                                    ",",
                                    "."
                                  )
                                : this.replaceAll(
                                    (
                                      this.getYearHourValue(
                                        this.state.sep_2_value_type
                                      ) * this.state.salary.taxable.sep_2.hours
                                    ).toLocaleString(),
                                    ",",
                                    "."
                                  )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.salary.taxable.sep_3.hours > 0 ? (
                        <div className="summary-row-middle">
                          <div className="left-summary-row">
                            <div className="left-summary-row-detail">
                              Horas de
                            </div>
                            <div className="left-summary-row-detail-middle">
                              {this.state.manual_2}
                            </div>
                            <div className="left-summary-row-detail-right">
                              {moment(
                                this.state.signing_date,
                                "DD-MM-YYYY"
                              ).year()}
                            </div>
                          </div>
                          <div className="right-summary-row">
                            <div className="summary-row-title">Horas Sep 3</div>
                            <div className="summary-row-detail">
                              {this.state.salary.taxable.sep_3.hours}
                            </div>
                            <div className="summary-row-detail">
                              $
                              {this.state.sep_3_value_type == "" ||
                              !this.state.sep_3_value_type
                                ? this.replaceAll(
                                    Math.round(
                                      this.state.salary.taxable.sep_3.salary /
                                        this.state.salary.taxable.sep_3.hours
                                    ).toLocaleString(),
                                    ",",
                                    "."
                                  )
                                : this.replaceAll(
                                    this.getYearHourValue(
                                      this.state.sep_3_value_type
                                    ).toLocaleString(),
                                    ",",
                                    "."
                                  )}
                            </div>
                            <div className="summary-row-detail">
                              $
                              {this.state.sep_3_value_type == "" ||
                              !this.state.sep_3_value_type
                                ? this.replaceAll(
                                    this.state.salary.taxable.sep_3.salary.toLocaleString(),
                                    ",",
                                    "."
                                  )
                                : this.replaceAll(
                                    (
                                      this.getYearHourValue(
                                        this.state.sep_3_value_type
                                      ) * this.state.salary.taxable.sep_3.hours
                                    ).toLocaleString(),
                                    ",",
                                    "."
                                  )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="summary-first-block">
                      <div className="legend-container">
                        <div className="legend-bottom">
                          Bonos otorgados por el Ministerio de Educación
                        </div>
                      </div>
                      <div className="basic-middle-summary">
                        {this.state.salary.taxable.brp_titulo.salary > 0 ? (
                          <div className="summary-row-block">
                            <div className="summary-row-title-last">
                              BRP Título
                            </div>
                            <div className="summary-row-detail"></div>
                            <div className="summary-row-detail"></div>
                            <div className="summary-row-detail">
                              $
                              {this.replaceAll(
                                Math.round(
                                  this.state.salary.taxable.brp_titulo.salary
                                ).toLocaleString(),
                                ",",
                                "."
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.salary.taxable.brp_mencion.salary > 0 ? (
                          <div className="summary-row-block">
                            <div className="summary-row-title-last">
                              BRP Mención
                            </div>
                            <div className="summary-row-detail"></div>
                            <div className="summary-row-detail"></div>
                            <div className="summary-row-detail">
                              $
                              {this.replaceAll(
                                Math.round(
                                  this.state.salary.taxable.brp_mencion.salary
                                ).toLocaleString(),
                                ",",
                                "."
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.salary.taxable.ley.salary > 0 ? (
                          <div className="summary-row-block">
                            <div className="summary-row-title-last">
                              Bono Prop. Ley 19410 - 19933
                            </div>
                            <div className="summary-row-detail"></div>
                            <div className="summary-row-detail"></div>
                            <div className="summary-row-detail">
                              $
                              {this.replaceAll(
                                Math.round(
                                  this.state.salary.taxable.ley.salary
                                ).toLocaleString(),
                                ",",
                                "."
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.salary.taxable.ley_pie.salary > 0 ? (
                          <div
                            className={
                              second_block_row_salaries.reduce((count, val) => {
                                return val == 0 ? count + 1 : count;
                              }, 0) > 0
                                ? "summary-row-block"
                                : "summary-row-last"
                            }
                          >
                            <div className="summary-row-title-last">
                              Bono Prop. Ley 19410 - 19933 PIE
                            </div>
                            <div className="summary-row-detail"></div>
                            <div className="summary-row-detail"></div>
                            <div className="summary-row-detail">
                              $
                              {this.replaceAll(
                                Math.round(
                                  this.state.salary.taxable.ley_pie.salary
                                ).toLocaleString(),
                                ",",
                                "."
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="flex-filler"></div>
                      </div>
                    </div>
                    {this.state.segment_assignation > 0 ||
                    this.state.complementary_payroll > 0 ||
                    this.state.sep_1_value != 0 ||
                    (this.state.sep_2_value != 0 &&
                      !isNaN(this.state.sep_2_value)) ||
                    this.state.sep_3_value_type != undefined ? (
                      <div className="summary-first-block">
                        <div className="legend-container">
                          <div className="legend-bottom-2">
                            Bonos Complementarios para Carrera Docente
                          </div>
                        </div>
                        <div className="basic-middle-summary">
                          {this.state.segment_assignation > 0 ? (
                            <div className="summary-row-block">
                              <div className="summary-row-title-last">
                                Asignación de Tramo
                              </div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail">
                                $
                                {this.replaceAll(
                                  Math.round(
                                    this.state.segment_assignation
                                  ).toLocaleString(),
                                  ",",
                                  "."
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.complementary_payroll > 0 ? (
                            <div className="summary-row-block">
                              <div className="summary-row-title-last">
                                Planilla Complementaria
                              </div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail">
                                $
                                {this.replaceAll(
                                  Math.round(
                                    this.state.complementary_payroll
                                  ).toLocaleString(),
                                  ",",
                                  "."
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.sep_1_value != 0 ? (
                            <div className="summary-row-block">
                              <div className="summary-row-title-last">
                                Bono Acordado SEP 1
                              </div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail">
                                $
                                {this.replaceAll(
                                  Math.round(
                                    this.state.sep_1_value *
                                      this.state.salary.taxable.sep_1.hours -
                                      this.calculateHeadshipHourPrice() *
                                        this.state.salary.taxable.sep_1.hours
                                  ).toLocaleString(),
                                  ",",
                                  "."
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.sep_2_value != 0 &&
                          !isNaN(this.state.sep_2_value) &&
                          this.state.salary.taxable.sep_2.hours > 0 ? (
                            <div className="summary-row-block">
                              <div className="summary-row-title-last">
                                Bono Acordado SEP 2
                              </div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail">
                                $
                                {this.replaceAll(
                                  Math.round(
                                    this.state.sep_2_value *
                                      this.state.salary.taxable.sep_2.hours -
                                      this.getYearHourValue(
                                        this.state.sep_2_value_type
                                      ) *
                                        this.state.salary.taxable.sep_2.hours
                                  ).toLocaleString(),
                                  ",",
                                  "."
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.sep_3_value_type != undefined ? (
                            <div className="summary-row-block">
                              <div className="summary-row-title-last">
                                Bono Acordado SEP 3
                              </div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail"></div>
                              <div className="summary-row-detail">
                                $
                                {this.replaceAll(
                                  Math.round(
                                    this.state.salary.taxable.sep_3.salary -
                                      this.getYearHourValue(
                                        this.state.sep_3_value_type
                                      ) *
                                        this.state.salary.taxable.sep_3.hours
                                  ).toLocaleString(),
                                  ",",
                                  "."
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="flex-filler"></div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="imposable-total-container">
                      <div className="imposable-total-filler"></div>
                      <div
                        className={
                          Object.values(this.state.salary.non_taxable).reduce(
                            (a, b) => a + b,
                            0
                          ) > 0
                            ? "imposable-total-detail-2"
                            : "imposable-total-detail-2-1"
                        }
                      >
                        <div className="summary-row-title">
                          Total remuneración imponible
                        </div>
                        <div className="summary-row-detail">
                          {this.state.salary.taxable.base.high_hours +
                            this.state.salary.taxable.base.middle_hours +
                            this.state.salary.taxable.sep_1.hours +
                            this.state.salary.taxable.sep_2.hours +
                            this.state.salary.taxable.sep_3.hours}
                        </div>
                        <div className="summary-row-detail"> </div>
                        <div className="summary-row-detail">
                          $
                          {this.replaceAll(
                            Math.round(
                              (this.state.segment_assignation
                                ? this.state.segment_assignation
                                : 0) +
                                (this.state.complementary_payroll
                                  ? this.state.complementary_payroll
                                  : 0) +
                                Object.values(
                                  this.overwriteTaxableSalaryValues(
                                    this.state.salary.taxable
                                  )
                                )
                                  .map((item) => item.salary)
                                  .reduce(
                                    (a, b) => Math.round(a) + Math.round(b)
                                  )
                            ).toLocaleString(),
                            ",",
                            "."
                          )}
                        </div>
                      </div>
                    </div>
                    {this.state.salary.non_taxable.movilization > 0 ? (
                      <div className="summary-row-middle-movilization">
                        <div className="left-summary-row">
                          <div className="left-summary-row-detail-2">
                            Bono de movilización
                          </div>
                        </div>
                        <div className="right-summary-row">
                          <div className="summary-row-title"></div>
                          <div className="summary-row-detail"></div>
                          <div className="summary-row-detail"></div>
                          <div className="summary-row-detail">
                            $
                            {this.replaceAll(
                              Math.round(
                                this.state.salary.non_taxable.movilization
                              ).toLocaleString(),
                              ",",
                              "."
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {Object.values(this.state.salary.non_taxable).reduce(
                      (a, b) => a + b
                    ) > 0 ? (
                      <div className="imposable-total-container">
                        <div className="imposable-total-filler"></div>
                        <div
                          className={
                            this.state.salary.non_taxable.movilization > 0
                              ? "imposable-total-detail-3"
                              : ""
                          }
                        >
                          <div className="summary-row-title">
                            Total remuneración no imponible
                          </div>
                          <div className="summary-row-detail"></div>
                          <div className="summary-row-detail"></div>
                          <div className="summary-row-detail">
                            $
                            {this.replaceAll(
                              Object.values(this.state.salary.non_taxable)
                                .reduce((a, b) => Math.round(a) + Math.round(b))
                                .toLocaleString(),
                              ",",
                              "."
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="foot-note-container">
                  <div className="foot-note">
                    La Fundación Astoreca actúa sólo como intermediaria de los
                    bonos otorgados por el Ministerio de Educación. Asimismo, si
                    el Ministerio de Educación otorgara otros bonos y
                    asignaciones anuales, éstos serán traspasados según lo
                    estipule la Ley.
                  </div>
                </div>
                <div className="optional-container">
                  <div className="optional">
                    {this.state.comment != "" ? (
                      <span className="bold underlined">Observación:</span>
                    ) : (
                      ""
                    )}{" "}
                    {this.state.comment}
                  </div>
                </div>
                <div className="flex-filler"></div>
                {/*<div className="signatures-container">
                  <div className="signatures">
                    <div className="employer-signature">
                      <div className="signature-line"></div>
                      <div className="signature-label">Firma</div>
                      <div className="signature-label">Fundación Astoreca</div>
                    </div>
                    <div className="filler-signature"></div>
                    <div className="teacher-signature">
                      <div className="signature-line"></div>
                      <div className="signature-label">Firma</div>
                      <div className="signature-label">
                        {this.state.teacher.name}
                      </div>
                    </div>
                  </div>
                </div>*/}
                <div className="flex-filler-25"></div>
                <div className="page-number">2/2</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    contractInfo: JSON.parse(JSON.stringify(state.contractInfo)),
  };
}

export default checkAuth(connect(mapStateToProps, null)(ProtectedPage));



// WEBPACK FOOTER //
// ./src/components/protected/ProtectedPage.js